import { useQuery } from '@tanstack/react-query';
import type { AgentApiCompanyTagsIndex } from '@/types/serializers';

/**
 * 企業タグ一覧を取得するフック
 */
export default function useCompanyTags() {
  return useQuery({
    queryKey: ['/agent/api/company_tags'],
    queryFn: async () => {
      const response = await fetch('/agent/api/company_tags', {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error('Failed to fetch company tags');
      }

      const data: AgentApiCompanyTagsIndex = await response.json();
      return data;
    },
  });
}
